import React from 'react';
import ComponentWrapper from '../../../components/layout/ComponentWrapper';
import { StudyCopyBlock } from '../index';

const MSI_CRC = () => (
    
    <ComponentWrapper>

        <StudyCopyBlock 
            // title="Study Design Details"
            description={`
                <p>The efficacy of KEYTRUDA was investigated in KEYNOTE&#8288;-&#8288;177, a multicenter, randomized, open-label, active-controlled trial that enrolled 307 patients with previously untreated unresectable or metastatic MSI&#8288;-&#8288;H or dMMR CRC. MSI or MMR tumor status was determined locally using polymerase chain reaction (PCR) or immunohistochemistry (IHC), respectively. Patients with autoimmune disease or a medical condition that required immunosuppression were ineligible. Patients were randomized (1:1) to receive KEYTRUDA 200&nbsp;mg intravenously every 3 weeks or investigator’s choice of the following chemotherapy regimens given intravenously every 2 weeks: mFOLFOX6 (oxaliplatin, leucovorin, and FU) or mFOLFOX6 in combination with either bevacizumab or cetuximab: Oxaliplatin 85&nbsp;mg/m<sup>2</sup>, leucovorin 400&nbsp;mg/m<sup>2</sup> (or levoleucovorin 200&nbsp;mg/m<sup>2</sup>), and FU 400&nbsp;mg/m<sup>2</sup> bolus on Day 1, then FU 2400&nbsp;mg/m<sup>2</sup> over 46–48 hours. Bevacizumab 5&nbsp;mg/kg on Day 1 or cetuximab 400&nbsp;mg/m<sup>2</sup> on first infusion, then 250&nbsp;mg/m<sup>2</sup> weekly; FOLFIRI (irinotecan, leucovorin, and FU) or FOLFIRI in combination with either bevacizumab or cetuximab: Irinotecan 180&nbsp;mg/m<sup>2</sup>, leucovorin 400&nbsp;mg/m<sup>2</sup> (or levoleucovorin 200&nbsp;mg/m<sup>2</sup>), and FU 400&nbsp;mg/m<sup>2</sup> bolus on Day 1, then FU 2400&nbsp;mg/m<sup>2</sup> over 46–48 hours. Bevacizumab 5&nbsp;mg/kg on Day 1 or cetuximab 400&nbsp;mg/m<sup>2</sup> on first infusion, then 250&nbsp;mg/m<sup>2</sup> weekly. Treatment with KEYTRUDA or chemotherapy continued until RECIST v1.1-defined progression of disease as determined by the investigator or unacceptable toxicity. Patients treated with KEYTRUDA without disease progression could be treated for up to 24 months. Assessment of tumor status was performed every 9 weeks. Patients randomized to chemotherapy were offered KEYTRUDA at the time of disease progression.</p>
                <p>The median duration of exposure to KEYTRUDA was 11.1 months (range: 1 day to 30.6 months).</p>
            `} 
        />

        <StudyCopyBlock 
            title="End Points"
            description={`
                <p>The main efficacy outcome measures were PFS as assessed by BICR according to RECIST v1.1, modified to follow a maximum of 10 target lesions and a maximum of 5 target lesions per organ, and OS.</p>
                <p>Additional efficacy outcome measures were ORR and DOR.</p>
            `} 
        />

        <StudyCopyBlock 
            title="Patient Characteristics"
            description={`
                <p>Patients randomized to chemotherapy were offered KEYTRUDA at the time of disease progression.</p>
                <p><b>Baseline Characteristics:</b></p>
                <ul> 
                    <li>Median age, years (range): 63 (24–93)</li>
                    <li>65 or older: 47%</li>
                    <li>Male: 50%</li>
                    <li>Race/ethnicity
                        <ul>
                            <li>White: 75%</li>
                            <li>Asian: 16%</li>
                        </ul>                    
                    </li>
                    <li>ECOG PS
                        <ul>
                            <li>0: 52%</li>
                            <li>1: 48%</li>
                        </ul>
                    </li>
                    <li>Received prior adjuvant or neoadjuvant chemotherapy: 27%</li>
                </ul>
                <p><b>Among 154 patients randomized to receive chemotherapy, 143 received chemotherapy per protocol</b></p>
                <ul>
                    <li>Chemotherapy received:
                        <ul>
                            <li>mFOLFOX6: 56%</li>
                            <li>FOLFIRI: 44%</li>
                            <li>Bevacizumab + mFOLFOX6 or FOLFIRI: 70%</li>
                            <li>Cetuximab + mFOLFOX6 or FOLFIRI: 11%</li>
                        </ul>
                    </li>
                </ul>
            `}
            definitions={`
                ECOG PS = Eastern Cooperative Oncology performance status.
            `} 
        />
 
    </ComponentWrapper>
);

export default MSI_CRC;
